import config from "../config";
import { ListActionProvider } from "@beeldit/core/actions/list/ListActionContext";
import { RemoveActionProvider } from "@beeldit/core/actions/remove/RemoveActionContext";
import { CreateActionProvider } from "@beeldit/core/actions/create/CreateActionContext";
import bookingsCalendarConfig from "../bookingsCalendarConfig";
import CalendarPage from "../components/CalendarPage";
import { EditActionProvider } from "../actions/edit/EditActionContext";
import { CancelActionProvider } from "../actions/cancel/CancelActionContext";
import { UncancelActionProvider } from "../actions/uncancel/UncancelActionContext";
import { EditActionProvider as CustomerEditActionProvider } from "@main/customers/actions/edit/EditActionContext";
import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";

function BookingsCalendarPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasCleanedUrl = useRef(false);

  // Al cargar la página por primera vez, limpiar los filtros de la URL si existen
  // Esto garantiza un comportamiento predecible del calendario
  useEffect(() => {
    if (location.search && !hasCleanedUrl.current) {
      // Si hay query params, limpiar la URL para forzar el uso de filtros por defecto
      hasCleanedUrl.current = true;
      navigate(location.pathname, { replace: true });
    }
  }, [location.search, location.pathname, navigate]);

  const tablePageParams = {
    modelConfig: bookingsCalendarConfig, // Configuración del modelo
    formDefaultValues: null,
    filters: null, // Usar null para que se carguen los filtros por defecto
    formFilterValues: null,
  };

  return (
    <ListActionProvider key={config.modelName}>
      <RemoveActionProvider>
        <CreateActionProvider>
          <CustomerEditActionProvider>
            <EditActionProvider>
              <CancelActionProvider>
                <UncancelActionProvider>
                  <CalendarPage {...tablePageParams} />
                </UncancelActionProvider>
              </CancelActionProvider>
            </EditActionProvider>
          </CustomerEditActionProvider>
        </CreateActionProvider>
      </RemoveActionProvider>
    </ListActionProvider>
  );
}

export default BookingsCalendarPage;
